import { render, staticRenderFns } from "./DeptoVenta.vue?vue&type=template&id=5ff28cf8&"
import script from "./DeptoVenta.vue?vue&type=script&lang=js&"
export * from "./DeptoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports